//router
import LayoutsRoute from "./router/layouts-route";

//css files
import "./assets/css/styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-notifications/lib/notifications.css";

import { NotificationContainer } from "react-notifications";

function App() {
  return (
    <div className="App">
      <LayoutsRoute />
      <NotificationContainer />
    </div>
  );
}

export default App;
